import { useTranslation } from 'react-i18next';
import HeaderComponent from '../../../../components/header/Header.component';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';
import GenericActionTable from '../../../../components/moduleCommonFormik/GenericActionTable';
import { useEffect, useState } from 'react';
import { POST, endpoints, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import { Card } from 'react-bootstrap';
import { changeDateFormatToIST, decode } from '../../../../utils/utils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import { cross } from '../../../../utils/Logo';
import _ from 'lodash';
import { convertToINR, getQueryParams } from '../../EstateManagement/EstateManagement.controller';
import { INSTALLMENT_COL } from '../../EstateManagement/Payment/EstatePayment.const';
import Loading from '../../../../components/portalComponents/Loading.component';

export const EstateInstallmentView = () => {
    const { t } = useTranslation();
    const [installmentRowData, setInstallmentRowData] = useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [searchParams] = useSearchParams();

    const plotId: any = decode(searchParams.get('plotId'));
    const type: any = decode(searchParams.get('type'));
    const entityId: any = decode(searchParams.get('entityId'));

    const queryParams = getQueryParams(searchParams);

    const installmentCol = INSTALLMENT_COL?.map((val: any) => {
        if (val?.fieldName === 'checkbox') {
            return { ...val, isDisabled: true };
        } else {
            return { ...val };
        }
    });

    useEffect(() => {
        (async () => {
            try {
                if (!queryParams.eg_pg_txnid) {
                    setIsLoading(true);
                    if (type.includes('LAND_PREMIUM')) {
                        // get landpremium installment table data
                        const installmentData = await POST(endpoints.scheduledPaymentDetailsSearch + `?paymentTypes=LAND_PREMIUM&plotIds=${plotId}&entityIds=${entityId}`, {
                            RequestInfo: requestInfo()
                        });

                        const updatedData = installmentData.data.paymentDetailsResponse
                            .reverse()
                            .slice(installmentData.data.paymentDetailsResponse.length > 1 ? 1 : 0) // to hide downpayment record
                            .filter((item: any) => item.paymentType === 'LAND_PREMIUM')
                            .map((item: any, id: number) => ({
                                ...item,
                                id: item.uuid,
                                dueDate: changeDateFormatToIST(item.dueDate),
                                SN: id + 1,
                                isChecked: item.paidAmount ? true : false,
                                isDefaultChecked: false,
                                totalDueAmount: convertToINR(item.totalDueAmount),
                                sgstPenalty: convertToINR(item.sgstPenalty),
                                cgstPenalty: convertToINR(item.sgstPenalty),
                                penaltyAmount: convertToINR(item.penaltyAmount),
                                interestAmount: convertToINR(item.interestAmount),
                                principalAmount: convertToINR(item.principalAmount),
                                isDisabled: true
                            }));

                        setInstallmentRowData(updatedData);
                    }
                }
                setIsLoading(false);
            } catch (err: any) {
                setIsLoading(false);
                let errMsg = err.response?.data?.errorMessage || t('SOMETHING_WENT_WRONG', 'Something went wrong');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
                console.log(err);
            }
        })();
    }, []);

    const onCheckHandler = (checkedItems: any) => {};

    const handleModalClose = (type: string) => {
        setModalDetails({ show: false });
    };

    return (
        <>
            <HeaderComponent />
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <div className='employee-creation-container bg-light m-auto px-5 py-4'>
                        <GenericHeader text={t('PAYMENT', 'Payment')} additionalClass='sub-text-style' />

                        {type === 'LAND_PREMIUM' && (
                            <Card className='card_border font-inter'>
                                <Card.Body>
                                    <div className='ps-2 py-2 d-flex justify-content-between'>
                                        <div className='formTitle m-0'>{'Land Premium'}</div>
                                    </div>
                                    <GenericActionTable
                                        columns={installmentCol}
                                        rowData={installmentRowData}
                                        hideSearchBar={true}
                                        itemsPerPage={10}
                                        highlightRow={true}
                                        hideFooter={true}
                                        onCheckHandler={onCheckHandler}
                                        checkType={`multiCheck`}
                                        serialCheckEnable={true}
                                    ></GenericActionTable>
                                </Card.Body>
                            </Card>
                        )}
                    </div>
                </>
            )}

            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose(modalDetails.type)}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose(modalDetails.type)}
            />
        </>
    );
};
